export default __webpack_public_path__ + "static/media/feedback_submittedicon.d4f08115.svg";